import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { Link, useNavigate } from "react-router-dom";
import { format } from "timeago.js";

import { publicRequest } from "../requestMethods";

const Container = styled.div`
  width: ${(props) => props.type !== "sm" && "360px"};
  gap: 10px;
  margin-bottom: ${(props) => (props.type === "sm" ? "10px" : "45px")};
  cursor: pointer;
  display: ${(props) => props.type === "sm" && "flex"};
`;

const Image = styled.img`
  width: ${(props) => (props.type === "sm" ? "150px" : "100%")};
  height: ${(props) => (props.type === "sm" ? "120px" : "202px")};
  object-fit: cover;
  background-color: #999;
  flex: 1;
`;

const Desc = styled.div`
  display: flex;
  margin-top: ${(props) => props.type !== "sm" && "16px"};
  gap: 12px;
  flex: 1;
`;
const ChannelImg = styled.img`
  border-radius: 50%;
  height: 36px;
  width: 36px;
  background-color: #999;
  display: ${(props) => props.type === "sm" && "none"};
  cursor: pointer;
`;
const Texts = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
`;
const VideoTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: ${({ theme }) => theme.text};
`;
const ChanelName = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.textSoft};
  margin: 9px 0px;
`;
const Views = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.textSoft};
`;

const Card = ({ type, video }) => {
  const [channel, setChannel] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    const fetchChannel = async () => {
      const res = await publicRequest.get(`/users/find/${video?.userId}`);
      setChannel(res.data);
    };
    fetchChannel();
  }, [video?.userId]);

  const handleClick = (e) => {
    e.preventDefault();
    const channelUserId = e.currentTarget.id;
    navigate(`/profile/${channelUserId}`);
  };

  return (
    <Link to={`/video/${video?._id}`} style={{ textDecoration: "none" }}>
      <Container type={type}>
        <Image type={type} src={video?.imgUrl} />
        <Desc type={type}>
          <ChannelImg
            type={type}
            src={channel?.img}
            id={channel?._id}
            onClick={handleClick}
          />
          <Texts>
            <VideoTitle>{video?.title}</VideoTitle>
            <ChanelName>{channel?.name}</ChanelName>
            <Views>
              {video?.views} views • {format(video?.createdAt)}
            </Views>
          </Texts>
        </Desc>
      </Container>
    </Link>
  );
};

export default Card;
